module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.form.card.status_id != 8 && _vm.$root.checkRule('card/edit/create')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.save,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 3 && _vm.$root.checkRule('card/edit/create')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.enrollmentConfirmationPrint,
      "iconclass": "fa fa-paper-plane-o",
      "label": "Igénylési igazolás"
    },
    model: {
      value: (_vm.is_print_enroll),
      callback: function($$v) {
        _vm.is_print_enroll = $$v
      },
      expression: "is_print_enroll"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 3 && _vm.$root.checkRule('card/edit/print')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.print,
      "iconclass": "fa fa-print",
      "label": "Nyomtat"
    },
    model: {
      value: (_vm.is_print),
      callback: function($$v) {
        _vm.is_print = $$v
      },
      expression: "is_print"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 5 && _vm.$root.checkRule('card/edit/print') && _vm.cert_file_exists) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printBizonylat
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v("Bizonylat nyomtat")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 9 || _vm.form.card.status_id == 10) && _vm.$root.checkRule('card/edit/allow')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v("Igénylés elfogadás")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 5 || _vm.form.card.status_id == 7) && _vm.$root.checkRule('card/edit/ban')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(8)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("Letiltás")]) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 5 && _vm.$root.checkRule('card/edit/suspend')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(7)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v("Felfüggesztés")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 7 || _vm.form.card.status_id == 11) && _vm.$root.checkRule('card/edit/activate')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(5)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v("Aktíválás")]) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 4 && _vm.$root.checkRule('card/edit/waste')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(8)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("Selejt (Letiltás)")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [(_vm.form.card.status_id != 8 && _vm.$root.checkRule('card/edit/create')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.save,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 3 && _vm.$root.checkRule('card/edit/create')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.enrollmentConfirmationPrint,
      "iconclass": "fa fa-paper-plane-o",
      "label": "Igénylési igazolás"
    },
    model: {
      value: (_vm.is_print_enroll),
      callback: function($$v) {
        _vm.is_print_enroll = $$v
      },
      expression: "is_print_enroll"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 3 && _vm.$root.checkRule('card/edit/print')) ? _c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.print,
      "iconclass": "fa fa-print",
      "label": "Nyomtat"
    },
    model: {
      value: (_vm.is_print),
      callback: function($$v) {
        _vm.is_print = $$v
      },
      expression: "is_print"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 5 && _vm.$root.checkRule('card/edit/print') && _vm.cert_file_exists) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printBizonylat
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v("Bizonylat nyomtat")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 9 || _vm.form.card.status_id == 10) && _vm.$root.checkRule('card/edit/allow')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v("Igénylés elfogadás")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 5 || _vm.form.card.status_id == 7) && _vm.$root.checkRule('card/edit/ban')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(8)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("Letiltás")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 5 || _vm.form.card.status_id == 11) && _vm.$root.checkRule('card/edit/suspend')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(7)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v("Felfüggesztés")]) : _vm._e(), _vm._v(" "), ((_vm.form.card.status_id == 7 || _vm.form.card.status_id == 11) && _vm.$root.checkRule('card/edit/activate')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(5)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v("Aktíválás")]) : _vm._e(), _vm._v(" "), (_vm.form.card.status_id == 4 && _vm.$root.checkRule('card/edit/waste')) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeCardStatus(8)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("Selejt (Letiltás)")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._m(3), _vm._v(" "), ((_vm.form.card.status_id == 9 || _vm.form.card.status_id == 10)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Fotó")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.form.card.owner_photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('textareabox', {
    attrs: {
      "cstyle": "height: 150px",
      "id": "photo_email",
      "label": "Email",
      "errors": _vm.errors,
      "name": "photo_email"
    },
    model: {
      value: (_vm.photo_email),
      callback: function($$v) {
        _vm.photo_email = $$v
      },
      expression: "photo_email"
    }
  }), _vm._v(" "), (_vm.form.card.status_id == 9) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.badPhotoEmailSend
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("Email küldés")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.badPhotoEmailSend
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("Email újraküldés")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.owner.neptundata != undefined && _vm.owner.show_student_status) ? _c('ul', {
    staticClass: "tree",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, _vm._l((_vm.owner.neptundata), function(nd) {
    return _c('li', [_c('i', {
      staticClass: "fa fa-graduation-cap"
    }), _vm._v("\n                      " + _vm._s(nd.SZAK_MEGN) + " (" + _vm._s(nd.SZAKKOD) + ") - " + _vm._s(nd.TAGOZAT) + " - "), _c('span', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(nd.STATUSZ))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.owner.kollegiumi_szoba != undefined) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                    Kollégiumi szoba: " + _vm._s(_vm.owner.kollegiumi_szoba) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.owner.felvetelt_nyert_kollegium != false) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                    Felvételt nyert kollégium: "), _c('strong', [_vm._v(_vm._s(_vm.owner.felvetelt_nyert_kollegium.kollegium))]), _vm._v(" (" + _vm._s(_vm.owner.felvetelt_nyert_kollegium.idoszak) + ")\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.owner.golyahet != undefined && _vm.owner.golyahet) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                    Gólyahétre jönne\n                  ")]) : _vm._e(), _vm._v(" "), _c('select2ajax', {
    attrs: {
      "url": "card_owner/search",
      "disabled": (this.form.card.id != 0 || this.form.card.owner_id != 0) ? true : false,
      "change": _vm.ownerChange,
      "id": "owner_id",
      "label": "Kártyabirtokos",
      "errors": _vm.errors,
      "name": "owner_id"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.$set(_vm.form, "owners", $$v)
      },
      expression: "form.owners"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "true",
      "id": "card_number",
      "label": "Kártyaszám",
      "errors": _vm.errors,
      "name": "username"
    },
    model: {
      value: (_vm.form.card.card_number),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "card_number", $$v)
      },
      expression: "form.card.card_number"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "chip_id",
      "label": "Chip ID",
      "errors": _vm.errors,
      "name": "chip_id"
    },
    model: {
      value: (_vm.form.card.chip_id),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "chip_id", $$v)
      },
      expression: "form.card.chip_id"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.card.status_id == 4),
      expression: "form.card.status_id == 4"
    }],
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "true",
      "id": "rf_id",
      "label": "RF ID",
      "errors": _vm.errors,
      "name": "rf_id"
    },
    model: {
      value: (_vm.form.card.rf_id),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "rf_id", $$v)
      },
      expression: "form.card.rf_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.form.card.rf_id && _vm.$root.checkRule('card/edit/rfread')),
      expression: "!this.form.card.rf_id && $root.checkRule('card/edit/rfread')"
    }],
    staticClass: "btn btn-white",
    staticStyle: {
      "margin-top": "15px",
      "display": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rfpopupShow
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _vm._v("RF beolvasása")])])]), _vm._v(" "), (this.form.card.rf_id != '' && (this.form.card.status_id == 5 || this.form.card.status_id == 7 || this.form.card.status_id == 8)) ? _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "show_rf_id",
      "label": "RF ID",
      "name": "show_rf_id"
    },
    model: {
      value: (_vm.form.card.rf_id),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "rf_id", $$v)
      },
      expression: "form.card.rf_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('combobox', {
    attrs: {
      "disabled": "true",
      "change": _vm.statusChange,
      "id": "status_id",
      "label": "Státusz",
      "errors": _vm.errors,
      "name": "status_id"
    },
    model: {
      value: (_vm.form.statuses),
      callback: function($$v) {
        _vm.$set(_vm.form, "statuses", $$v)
      },
      expression: "form.statuses"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "ad_username",
      "disabled": !this.ad_canedit,
      "id": "ad_username",
      "label": "AD felh.név",
      "errors": _vm.errors,
      "name": "ad_username"
    },
    model: {
      value: (_vm.form.card.owner_ad_username),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "owner_ad_username", $$v)
      },
      expression: "form.card.owner_ad_username"
    }
  }), _vm._v(" "), (_vm.form.card.remanufactured != undefined) ? _c('toggle', {
    attrs: {
      "id": "remanufactured",
      "label": "Újragyártott",
      "name": "remanufactured"
    },
    model: {
      value: (_vm.form.card.remanufactured),
      callback: function($$v) {
        _vm.$set(_vm.form.card, "remanufactured", $$v)
      },
      expression: "form.card.remanufactured"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._m(4), _vm._v(" "), (_vm.rulesShow) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', [_vm._v("Érvényesség")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Engedélyezve")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Elsődleges")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jogSzerkesztes),
      expression: "jogSzerkesztes"
    }]
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.form.card.rules), function(rule, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(rule.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.valid_from) + " - " + _vm._s(rule.valid_to))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(rule.public.selected) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e(), (!rule.public.selected) ? _c('i', {
      staticClass: "fa fa-times"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(rule.primary.selected) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e(), (!rule.primary.selected) ? _c('i', {
      staticClass: "fa fa-times"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.jogSzerkesztes),
        expression: "jogSzerkesztes"
      }]
    }, [_c('ul', {
      staticClass: "icon-list"
    }, [_c('li', {
      staticClass: "dropdown"
    }, [_vm._m(5, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "dropdown-header"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.editRule(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("Szerkeszt")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.ruleDel(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    }), _vm._v("Töröl")])])])])])])])
  }), 0)]) : _c('div', [_vm._v("\n                    Nem található felvitt jog.\n                  ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jogSzerkesztes),
      expression: "jogSzerkesztes"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newRuleButtonClick
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új jog hozzáadása")])])])])])])])]), _vm._v(" "), (_vm.rule_popup) ? _c('rulepopup', {
    attrs: {
      "card": _vm.form.card,
      "card2rule": _vm.card2rule,
      "addrule": _vm.addRule,
      "hidepopup": _vm.hideRulePopup
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rf_popup),
      expression: "rf_popup"
    }],
    staticClass: "modal-content no-overlay",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "rf_popup"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rfpopupHide
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Kártya RFID beolvasása")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("Érintse a kártyát az olvasóhoz")]), _vm._v(" "), _c('svg', {
    staticClass: "preloader-svg",
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 66 66"
    }
  }, [_c('circle', {
    attrs: {
      "stroke": "#dbdbdb",
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  }), _c('circle', {
    staticClass: "preloader-svg-path",
    attrs: {
      "stroke": "#666",
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })]), _vm._v(" "), (_vm.rf_popup_msg != '') ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.rf_popup_msg))]) : _vm._e(), _vm._v(" "), (_vm.rf_popup_msg != '') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setupDownload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Kártyaolvasó illesztő letöltése")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rfpopupHide
    }
  }, [_vm._v("Bezár")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Kártyák")]), _vm._v(" "), _c('li', [_vm._v("Kártya")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Kártya")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Kártya")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Jogok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62e67863"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/card.vue
// module id = 58
// module chunks = 0